export default "__VITE_ASSET__D60BQLGs__"